// Reads the runtime configuration injected by /config.js into window.__CONFIG__.
// See public/config.js for the key contract; the deploy step overwrites that
// file from stack outputs.

export interface AppConfig {
  cognitoDomain: string;
  userPoolClientId: string;
  region: string;
  apiBase: string;
}

declare global {
  interface Window {
    __CONFIG__?: Partial<AppConfig>;
  }
}

function read(): AppConfig {
  const raw = window.__CONFIG__ ?? {};
  return {
    cognitoDomain: (raw.cognitoDomain ?? '').replace(/\/$/, ''),
    userPoolClientId: raw.userPoolClientId ?? '',
    region: raw.region ?? 'ap-southeast-2',
    apiBase: raw.apiBase ?? '/api',
  };
}

export const config: AppConfig = read();

export function configReady(): boolean {
  return (
    config.cognitoDomain.length > 0 &&
    config.userPoolClientId.length > 0 &&
    !config.userPoolClientId.startsWith('REPLACE_')
  );
}
